<div
  id="userMenu"
  class="header-menu"
  [ngClass]="{
    'va-global-header-icon-focus': isUserSelected
  }"
>
  <span
    nz-dropdown
    nzBackdrop="false"
    [nzDropdownMenu]="accountMenu"
    nzTrigger="click"
    [(nzVisible)]="isUserSelected"
    (nzVisibleChange)="isOpen($event)"
    nzPlacement="bottomRight"
  >
    <va-icon
      name="user"
      class="fa-lg left-icon"
      nz-tooltip
      nzTooltipTitle="Account"
      nzTooltipPlacement="bottom"
    ></va-icon>
  </span>

  <nz-dropdown-menu #accountMenu="nzDropdownMenu">
    <div nz-menu class="va-global-header-dd-menu">
      <div class="header-container">
        <span class="header">Hello, {{ globalSettings.userName }} </span>
        <div class="sub-header">
          Your Account Settings
        </div>
      </div>
      <div class="list-group">
        <div
          nz-menu-item
          class="account-option-list"
          *ngIf="globalSettings.watcherAccess == true"
        >
          <a [routerLink]="['watchlist']">Manage My Watchlists</a>
        </div>
        <div nz-menu-item class="account-option-list">
          <a (click)="onClickGlobalSettings()">Global Settings</a>
        </div>
        <div nz-menu-item class="account-option-list">
          <a [routerLink]="['alert_settings']">Alerts Manager</a>
        </div>
        <div
          nz-menu-item
          class="account-option-list"
          *ngIf="globalSettings.showCorporateEntitlements"
        >
          <a [routerLink]="['entitlements/corporates']">View My Entitlements</a>
        </div>
        <div
          nz-menu-item
          class="account-option-list"
          *ngIf="
            globalSettings.sellsideBrokerShortname == undefined &&
            globalSettings.showEntitlementsPage == true &&
            !globalSettings.showCorporateEntitlements
          "
        >
          <!-- <a routerLink="/entitlements" routerLinkActive="active">Entitlements</a> -->
          <!-- <a href="{{ legacyUrl }}/entitlements">Entitlements</a> -->
          <a [routerLink]="['entitlements']">View My Entitlements</a>
        </div>
        <div
          nz-menu-item
          class="account-option-list"
          *ngIf="globalSettings.show_set_passwd == false"
        >
          <a href="{{ projectArkUrl }}/password/change">Change My Password</a>
        </div>
        <div
          nz-menu-item
          class="account-option-list"
          *ngIf="globalSettings.show_set_passwd == true"
        >
          <a href="{{ projectArkUrl }}/password/set">Set Password</a>
        </div>
        <div
          nz-menu-item
          class="account-option-list"
          *ngIf="globalSettings.isAdmin"
        >
          <a href="{{ legacyDomain }}/admin/">Admin Page</a>
        </div>
        <div nz-menu-divider></div>
        <div nz-menu-item class="account-option-list">
          <a href="{{ projectArkUrl }}/signout">Sign out</a>
        </div>
      </div>
    </div>
  </nz-dropdown-menu>
</div>
